import {
  ChangeDetectionStrategy, Component, Input, TemplateRef, viewChild,
} from '@angular/core'

@Component({
  selector: 'kb-footer-link',
  templateUrl: './footer-link.component.html',
  styleUrls: ['./footer-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class FooterLinkComponent {
  @Input({ required: true }) public href!: string
  @Input() public target?: string
  public content = viewChild.required(TemplateRef)
}
